var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnoonuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#D90217"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9158 27.8996C25.3443 27.8996 28.5932 24.8926 28.5932 21.1043C28.5932 15.245 19.0448 15.8309 19.0448 13.8409C19.0448 13.1776 19.7588 12.5143 21.1832 12.5143C23.4825 12.5143 25.778 13.8041 26.7687 14.858L29.6998 11.1472C27.5987 9.23463 24.391 8.09961 21.1795 8.09961C14.6182 8.09961 12.8611 8.09961 6.2998 8.09961L6.32972 8.27649C6.98398 11.3314 8.91683 13.2181 12.3227 14.1173C11.489 14.2979 10.5992 14.7217 9.96738 15.186C11.1413 17.2055 14.5995 18.9006 18.469 19.9914C20.5776 20.6547 22.4917 21.0711 22.4917 22.1582C22.4917 22.8989 21.6992 23.5254 20.4692 23.5254C17.7736 23.5254 14.8425 21.845 13.6537 20.5957L10.4422 24.4614C12.7788 26.6872 16.3866 27.8996 19.9121 27.8996H19.9158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnoonuIcon);
export default __webpack_public_path__ + "static/media/snoonu-icon.349acb95c739a00057e15ef3ea8dde88.svg";
export { ForwardRef as ReactComponent };